/**
 * Announcement Slug Names from Wordpress Pages
 * Note : Do not change the slug values unless they are changed in wordpress
 */
export enum AnnouncementSlugs {
  CERTIFICATION_SLUG = 'genesys-technical-certifications-important-announcement',
  CERTIFICATION_BADGE_SLUG = 'claim-your-badge',
  GENESYS_ENGAGE_SLUG = 'genesysengage',
  POINTILLIST_SLUG = 'pointillist',
  USER_DASHBOARD_SLUG = 'user-dashboard',
  MESSAGE_INBOX_NORECORDS_SLUG = 'message-inbox-no-records-note',
  NEW_ROLE_BASED_LEARNING_PATHS_SLUG = 'new-role-based-learning-paths',
  JUST_ADDED_MORE_FREE_LEARNING_CONTENT_SLUG = 'just-added-more-free-learning-content',
}
